const initialState = () => ({
  page: 1,
  display_daterange: "",
  daterange: [],
  payment_status: "",
  payment_type: "",
  search: "",
  selected_tab: 0,
  // Company: the borrower's employer, typed free-hand
  employer_name: "",
});

export default {
  namespaced: true,
  state: initialState(),

  mutations: {
    RESET_FILTERS(state) {
      Object.assign(state, initialState());
    },
  },
  actions: {
    resetFilters({ commit }) {
      commit("RESET_FILTERS");
    },
  },
  getters: {
    // Fresh copy of the filter defaults; used by filterChipsMixin's
    // dev coverage guard to detect applied-but-unregistered filters.
    getInitialFilters: () => initialState(),
    getFilters: (state) => {
      return state;
    },
  },
};
